import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Name:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Managers:", -1)
const _hoisted_3 = { class: "region-edit-modal__button" }
const _hoisted_4 = { class: "region-edit-modal__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_som_alert = _resolveComponent("som-alert")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.showModalRef,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModalRef) = $event)),
    preset: "card",
    title: _ctx.state.editableRegion.id ? 'Edit Region' : 'Create Region',
    class: "region-edit-modal",
    "block-scroll": false,
    onClose: _ctx.closeModal
  }, {
    action: _withCtx(() => [
      _createVNode(_component_n_space, { justify: "space-between" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_n_button, {
              class: "region-edit-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_n_button, {
              class: "region-edit-button",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleUpdate()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_n_space, {
        vertical: "",
        class: "inputs"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_n_input, {
            status: _ctx.isNameValid ? '' : 'error',
            type: "text",
            value: _ctx.state.editableRegion.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.editableRegion.name) = $event))
          }, null, 8, ["status", "value"]),
          (!_ctx.isNameValid)
            ? (_openBlock(), _createBlock(_component_som_alert, {
                key: 0,
                type: "error",
                dismissible: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Name cannot be empty")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_2,
          _createVNode(_component_n_select, {
            multiple: "",
            filterable: "",
            options: _ctx.state.managerOptions,
            value: _ctx.state.selectedManagerIds,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedManagerIds) = $event))
          }, null, 8, ["options", "value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show", "title", "onClose"]))
}